import { useState } from "react";

import legitimateLogo from "@/assets/logos/HoverSymbol.svg";
import legitimateWordmark from "@/assets/logos/Wordmark.svg";
import { Button } from "@/components/ui/button";
import { LOGIN_URL } from "@/data/auth";

export const Splash = () => {
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <img src={legitimateLogo} alt="Legitimate Logo" className="w-12 h-12" />
      <h3 className="scroll-m-20 text-2xl tracking-tight mt-6 font-medium">
        Tag Management Dashboard
      </h3>
      <Button
        size="lg"
        className="w-[350px] py-2 my-9 font-medium"
        disabled={isLoggingIn}
        onClick={() => setIsLoggingIn(true)}
        asChild
      >
        <a href={LOGIN_URL}>Sign In</a>
      </Button>
      <img src={legitimateWordmark} alt="Legitimate wordmark" className="h-4" />
    </div>
  );
};
